import { render, staticRenderFns } from "./RapidFormCurrencyWrapper.vue?vue&type=template&id=5e06532b"
import script from "./RapidFormCurrencyWrapper.vue?vue&type=script&lang=js"
export * from "./RapidFormCurrencyWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports